import type { Theme } from '@mui/material';
import { styled } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';

export const Wrapper = styled('div')({
  width: '100%',
});

export const StyledDateTimePicker = styled(DateTimePicker, {
  shouldForwardProp: (prop) => prop !== '$error' && prop !== 'background' && prop !== 'lightError',
})<{
  background?: 'transparent' | 'white';
  $error?: boolean;
  lightError?: boolean;
}>(
  ({
    theme,
    background = 'transparent',
    $error: error,
    lightError,
  }: {
    theme?: Theme;
    background?: 'transparent' | 'white';
    $error?: boolean;
    lightError?: boolean;
  }) => ({
    width: '100%',
    minWidth: 'auto',

    '&.MuiTextField-root .MuiOutlinedInput-root': {
      padding: '6px 10px',
      backgroundColor: error && !lightError ? theme?.palette.error.light : background === 'transparent' ? 'transparent' : theme?.palette.common.white,
    },
    '&.MuiTextField-root .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderColor: error || lightError ? theme?.palette.error.main : theme?.palette.secondary.main,
    },
    '&.MuiTextField-root .Mui-error': {
      backgroundColor: error && !lightError ? theme?.palette.error.light : background === 'transparent' ? 'transparent' : theme?.palette.common.white,
    },
  })
);
